import axios from '@utils/axios';

const createConsultingRoom = {
  state: {
    name: '',
    enabled: false,
    doctor: 0
  },
  mutations: {
    setName(state, name) {
      state.name = name;
    },
    setEnabled(state, enabled) {
      state.enabled = enabled;
    },
    setDoctor(state, doctor) {
      state.doctor = doctor;
    }
  },
  actions: {
    createConsultingRoom(context) {
      return axios.put('admin/consultingrooms', {
        Name: context.state.name,
        IsEnabled: context.state.enabled,
        DoctorId: Number(context.state.doctor)
      });
    },
    resetContext(context) {
      context.commit('setName', '');
      context.commit('setEnabled', false);
      context.commit('setDoctor', 0);
    },
  },
  namespaced: true
};

export default createConsultingRoom;
